export default __webpack_public_path__ + "static/slider-2-0119d35dae2bac335684706d01893210.jpg";